import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const LoggerContext = /*#__PURE__*/createContext(null);
export const ProvideLogger = ({
  logger,
  children
}) => {
  if (!logger) {
    throw new Error('logger is not defined within ProvideLogger');
  }

  return /*#__PURE__*/_jsx(LoggerContext.Provider, {
    value: logger,
    children: children
  });
};
export const useLogger = () => useContext(LoggerContext);